import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { storyIntroductionText, storyTitleText } from '../../i18n/localizedContent'
import { AppUseSelector, AppUseDispatch } from '../../redux/hooks'
import { setStep, getWordDetail, wordDoesNotKnow } from '../../redux/actions/storyAction'
import CountDown from '../../containers/countdown/CountDown'
import { Link, useNavigate } from 'react-router-dom'
import { countDownType, storyStep } from '../../utils/constant'
import { HOME } from '../../routes/routeConstant'
import WithRedirect from '../../containers/WithRedirect'
import { AddWordToHackChinese, handleAddWordToSkritter } from '../../redux/actions/userAction'
import { getQuiz, getGeneralResult } from '../../redux/actions/quizAction'
import { REGEX } from 'utils/regex'
import { converterWord, getWordLine, getWordTypeFromStory, wordSimplified, getSentenceWords } from 'utils/helperFunction'
import WordDetail from 'containers/word-detail'
import WordExamplesModal from 'containers/modal/word-examples-modal'
import { CHECK_WORD_IS_CLICKED } from '../../redux/types'
import OneLineContent from 'containers/RenderStroyComponent/OneLineContent'

const Introduction: React.FC<any> = ({ credentials, story, quizDetail, user_auth_token, skritter_token }) => {
  const { t } = useTranslation('reader')
  const { memberId, storyLevel } = credentials
  const title = storyTitleText(story)
  const introduction = storyIntroductionText(story)
  const storyId = story?.id
  const dispatch = AppUseDispatch()
  const navigate = useNavigate()
  const { chineseWordFontSize } = AppUseSelector(({ dashboard }) => dashboard)
  const characterPreference = credentials?.customFields?.character
  const { wordDetails, isWordClick } = AppUseSelector(({ story }) => story)
  const extraDivRef = useRef<HTMLDivElement>(null)
  const contentWordRef = useRef<HTMLDivElement>(null)
  const [activeIndex, setActiveIndex] = useState('-1')
  const [storyWord, setStoryWord] = useState(story?.storyTitleContent)
  const [wordDetailVisible, setWordDetailVisible] = useState(false)
  const [openExampleModal, setOpenExampleModal] = useState(false)
  const [isImportanceOpen, setImportanceOpen] = useState(false)
  const [isMasteryOpen, setMasteryOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    if (JSON.stringify(story) === '{}') {
    } else {
      if (!quizDetail?.quiz && storyId && storyLevel) {
        getQuiz(storyId, storyLevel).then((result: any) => {
          if (result.memberAnswer) {
            getGeneralResult(storyId)
          }
        })
      }
    }
  }, [story])

  useEffect(() => {
    window.scrollTo(0, 0)
    setStep(storyStep.Intro)

    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const handleClickOutside = (event) => {
    const isInsideSpecificButtons = event.target.closest('[data-specific-buttons]')
    if (
      !isInsideSpecificButtons &&
      !contentWordRef.current?.contains(event.target) &&
      !extraDivRef.current?.contains(event.target)
    ) {
      if (wordDetailVisible && wordDetails?.word && !isWordClick) {
        const mastery = getWordTypeFromStory(wordDetails?.word, story, characterPreference)
        wordDoesNotKnow({
          word: wordSimplified(wordDetails?.word),
          storyId,
          mastery: mastery === 'word' ? undefined : mastery,
          page: 'story',
        })
        dispatch({ type: CHECK_WORD_IS_CLICKED, payload: false })
      }
      setWordDetailVisible(false)
      setImportanceOpen(false)
      setMasteryOpen(false)
      setActiveIndex('-1')
    } else if (isInsideSpecificButtons) {
      const mastery = getWordTypeFromStory(wordDetails?.word, story, characterPreference)
      if (wordDetailVisible && wordDetails?.word && !isWordClick) {
        wordDoesNotKnow({
          word: wordSimplified(wordDetails?.word),
          storyId,
          mastery: mastery === 'word' ? undefined : mastery,
          page: 'story',
        })
        dispatch({ type: CHECK_WORD_IS_CLICKED, payload: false })
      }
    }
  }

  useEffect(() => {
    if (openExampleModal) {
      return
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [extraDivRef, contentWordRef, openExampleModal, wordDetailVisible, isWordClick, wordDetails])

  const handle = {
    onClickWord: (event, word, sentence, key) => {
      if (isMobile) {
        const targetElement = document.getElementById(key)
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' })
        }
      }
      if (typeof word !== 'string' && !REGEX.specialChars.test(word?.word)) {
        const storyWords = storyWord
          .filter?.((wordInfo) => {
            if (
              wordInfo?.word.includes('<p>') ||
              wordInfo?.word.includes('</p>') ||
              wordInfo?.word.includes('</p><p>')
            ) {
            } else {
              return wordInfo
            }
          })
          ?.filter((wordInfo: any) => wordInfo?.word !== word?.word)
        setStoryWord(storyWords)
        handle.translateWord(event, sentence)
      }
      setActiveIndex(activeIndex === key ? `-1` : key)
      event.preventDefault()
      event.stopPropagation()
    },
    translateWord: async (event: any, sentence: any) => {
      if (
        (event.type === 'mouseover' || event.type === 'click') &&
        event.target.innerText &&
        event.target.innerText.length > 0
      ) {
        const word = event.target.innerText
        if (/^[&.-”“，、；？@!#$%^&*()]+$/.test(word) || word.trim() === '。') {
          return
        }
        const wordTranslate = story?.storyTitleContent?.filter(
          (iword) => converterWord(iword?.word, characterPreference) === word,
        )
        if (wordTranslate && wordTranslate?.length > 0) {
          handle.getWordDetail(word, sentence, wordTranslate[0])
        }
      }
    },
    getWordDetail: async (word: string, sentence: any, data: any) => {
      const sentenceString = getWordLine(sentence)
      const basicDetail = {
        word,
        pinyin: data?.pinyin,
        english: data?.english,
        sentenceString,
        sentenceWords: getSentenceWords(sentence),
      }

      if (word && memberId) {
        setWordDetailVisible(true)
        const mastery = getWordTypeFromStory(word, story, characterPreference)
        await getWordDetail({
          detail: basicDetail,
          payload: { word: wordSimplified(word), memberId },
          wordType: mastery,
        }).then((res) => {
          handle.onWordClickIntegration({ word: res?.word, pinyin: res?.pinyin, english: res?.english })
        })
      }
    },
    onWordClickIntegration: (obj: any) => {
      if (user_auth_token) {
        AddWordToHackChinese({
          word: obj?.word,
          pinyin: obj?.pinyin,
          user_auth_token: user_auth_token,
        })
      }
      if (skritter_token) {
        handleAddWordToSkritter({
          word: obj?.word,
          translate: { pinyin: obj?.pinyin, english: obj?.english },
          title: story?.storyTitleContent,
          skritter_token: skritter_token,
        })
      }
    },
  }

  return (
    <div className='section-2'>
      <div className='section-intro w-container'>
        <div className='w-row'>
          <div className='w-col w-col-6'></div>
          <div className='w-col w-col-6 content-right'>
            <div className='section-countdown'>
              <div className='countdown-title'>{t('intro.nextLessonIn')}</div>
              <CountDown type={countDownType.Day} />
            </div>
          </div>
        </div>
        {story?.storyTitle && story?.storyTitleContent ? (
          <div className='w-row'>
            <div className='w-col w-col-6 content-left'>
              <div className='w-col w-col-6 section-story-img-mobile m-center m-al-c'>
                <img className='intro-img' alt={title.text} src={story?.image} />
              </div>
              <div className='w-col section-story-name'>
                <div
                  style={{
                    fontSize: chineseWordFontSize?.sessionTitle,
                    lineHeight: '1.5',
                    letterSpacing: '0px',
                    display: 'flex',
                    flexWrap: 'wrap',
                  }}
                  className='story-name'
                >
                  <div className='word_wrapper'>
                    {story?.storyTitle &&
                      story?.storyTitleContent?.map((wordObj, index) => (
                        <OneLineContent
                          key={index}
                          WIndex={index}
                          iterator={'INTRODUCTION-TITLE'}
                          isFontBold={true}
                          chineseWordFontSize={chineseWordFontSize}
                          wordObj={wordObj}
                          contentDetail={story?.storyTitleContent || []}
                          story={story}
                          showPinYin={true}
                          activeIndex={activeIndex}
                          handleClickWord={handle.onClickWord}
                        />
                      ))}
                  </div>
                </div>
                <div className='story-name-secondary word-break-class' lang={title.lang}>
                  {title.text}
                </div>
                {/* <div className='section-member-level'>
                  <span className='member-level'>{toUpperFirstLetter(storyLevel)}</span>
                  &nbsp;
                  {storyLevel && storyLevel.toLowerCase() === levelConst.beginner.toLowerCase() && (
                    <BeginnerStar />
                  )}
                  {storyLevel && storyLevel.toLowerCase() === levelConst.intermediate.toLowerCase() && (
                    <IntermediateStar />
                  )}
                  {storyLevel && storyLevel.toLowerCase() === levelConst.advanced.toLowerCase() && (
                    <AdvancedStar />
                  )}
                </div> */}
              </div>

              <div className='w-col story-summary' lang={introduction.lang}>
                {introduction.text}
              </div>

              <div className='w-col story-button mobile-button-stick'>
                <Link to={{ pathname: `/story/${story?.id}` }}>
                  <button className='button-2 w-button'>{t('intro.startLesson')}</button>
                </Link>
              </div>
            </div>
            <div className='w-col w-col-6 section-story-img m-center m-al-c'>
              <img className='intro-img' alt={title.text} src={story?.image} />
            </div>
          </div>
        ) : (
          <div className='w-row'>
            <div className='w-col w-col-12' style={{ textAlign: 'center', padding: '40px 20px' }}>
              <div className='item-title' style={{ marginBottom: '20px', fontSize: '32px', fontWeight: 'bold' }}>
                {t('story.notFoundTitle')}
              </div>
              <div style={{ marginBottom: '30px', fontSize: '18px' }}>
                <p>{t('story.notFoundBody')}</p>
              </div>
              <button className='button-2 w-button' onClick={() => navigate(HOME)} style={{ marginTop: '20px' }}>
                {t('story.backHome')}
              </button>
            </div>
          </div>
        )}
      </div>

      <WordDetail
        ref={contentWordRef}
        setOpenExampleModal={setOpenExampleModal}
        isImportanceOpen={isImportanceOpen}
        setImportanceOpen={setImportanceOpen}
        isMasteryOpen={isMasteryOpen}
        setMasteryOpen={setMasteryOpen}
        setWordDetailVisible={setWordDetailVisible}
        setActiveIndex={setActiveIndex}
        visible={wordDetailVisible}
        openExampleModal={openExampleModal}
        showMasterySection={true}
      />
      <WordExamplesModal
        ref={extraDivRef}
        openExampleModal={openExampleModal}
        setOpenExampleModal={setOpenExampleModal}
        setWordDetailVisible={setWordDetailVisible}
      />
    </div>
  )
}

const mapStateToProps = (state: any) => ({
  level: state.user.level,
  credentials: state.user.credentials,
  user_auth_token: state.user.user_auth_token,
  skritter_token: state.user.skritter_token,
  membership: state.user.membership,
  lastStep: state.story.lastStep,
  storyLevel: state.story.storyLevel,
  stories: state.story.stories,
  story: JSON.stringify(state.story.currentStory) === '{}' ? {} : state.story.currentStory,
  isGetData:
    (state.user.credentials?.level?.length > 0 || state.user.credentials.customFields?.level?.length > 0) &&
    JSON.stringify(state.story.currentStory) === '{}'
      ? true
      : false,
})

export default connect(mapStateToProps)(WithRedirect(Introduction))
